import { ApModal } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const StyledApModal = styled(ApModal)`
  .ap-modal-footer {
    display: flex;
    justify-content: flex-end;
  }

  .ap-button-secondary {
    margin-left: 16px;
  }
`;

export const InputModalFooter = styled.div`
  flex-direction: row-reverse;
`;

export const InputModalContent = styled.div`
  box-sizing: border-box;
  * {
    box-sizing: border-box;
  }
`;
